import { Fetch } from 'lib';
import { createShippingConfig } from 'services';

type RequestResponses = Awaited<ReturnType<typeof createShippingConfig>>;

type RequestParameters = {
  id: string;
};

type RequestBody = Parameters<typeof createShippingConfig>[number];

const updateShippingConfig = async (
  params: RequestParameters,
  body: RequestBody,
) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminShippingConfig/updateShippingConfig',
    method: 'PUT',
    params,
    body,
  });

export { updateShippingConfig };
